<template>
  <div class="party-richtext-panel">
    <div v-if="entry && entry.bodyContent" class="rich-body" v-html="entry.bodyContent" />
    <p v-else class="muted-copy">暂无已发布内容，请在管理后台维护</p>
  </div>
</template>

<script>
export default {
  name: 'PartyRichtextPanel',
  inject: ['front'],
  computed: {
    entry() {
      return (this.front.partyListItems && this.front.partyListItems[0])
        || (this.front.activePartyEntries && this.front.activePartyEntries[0])
        || null
    }
  }
}
</script>
